import { defineStore } from 'pinia'
import { IStore } from '@/contracts/modules/education/stores/IStore'

export default defineStore('modulesEducationV1', {
  state: (): IStore => {
    return {
      pack: null,
      questions: [],
      settings: null,
      connected: true,
      hasUserKey: false,
      isAnswerShown: false,
      error: null,
    }
  },
})
